<template>
        <!-- :title="$t('modal.work-rating')"  -->
    <a-modal 
        v-model="visible" 
        :closable="false" 
        width="80%"
        :cancel-text="$t('modal-btn.alter-cancel-btn-caption')" 
        @cancel="handleCancel"
        :ok-text="$t('ok')" 
        class="c_pdf_modal_container"
        
    >
        <a-spin  :spinning="isLoading" >
            <div class="c_pdf_viewer">
                <!-- {{pageCount}}/{{currentPage}} -->
                <pdf :src="src" 
                    @num-pages="pageCount = $event"
                    @page-loaded="currentPage = $event"
                    v-for="i in numPages"
                    :key="i"
                    :page="i"
                ></pdf>
            </div>
            <div style="display:flex;justify-content: end">
                <button class="ant-btn ant-btn-primary" @click.prevent="handleCancel()">Ok</button>
            </div>
        </a-spin>
    </a-modal>
</template>

<script>
import pdf from 'vue-pdf'
export default {
    name: "PdfViewerModal",
    components: {
        pdf
    },
    data(){
        return{
            visible: false,
            currentPage: 0,
			pageCount: 0,
            src: "",
			numPages: undefined,
            isLoading: true,
        }
    },
    methods: {
        showModal(url) {
            this.visible = true;
            this.src = pdf.createLoadingTask(url);
            this.src.promise.then(pdf => {
                this.numPages = pdf.numPages;
                this.isLoading = false;
            });
        },
        handleCancel(){
            this.visible = false;
        },
    }
}
</script>

<style lang="scss">
    .c_pdf_modal_container{
        .ant-modal-footer {
            display: none;
        }
    }
    .c_pdf_viewer{
        max-height: 650px;
        overflow: scroll;
        min-height: 650px;
    }

</style>